/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMerchantForPlatformAccount} from '../api'

 export const useQueryGetMerchantForPlatformAccount = createReactQueryHook('getMerchantForPlatformAccount', getMerchantForPlatformAccount)
